




























































import mixins from "vue-typed-mixins";
import { GeneralMixin } from "@/mixins/general-mixin";

/** Components */
import ParticipantSmallInfoCard from "@/components/participant/participant-small-info-card.vue";

/** Types */
type Unit = "kWh" | "uni" | "MWh";

interface MeasurementItem {
  key: string;
  translation?: string;
  title: string;
  subtitle: string;
  subtitleClass: string;
  iconColor: string;
  icon: string;
  consumption: number;
  unit: Unit;
}

/** Component definition */
export default mixins(GeneralMixin).extend({
  name: "MeasurementsHeading",
  components: { ParticipantSmallInfoCard },
  created() {
    this.getOverallInformation();
  },
  data() {
    const baseItems: MeasurementItem[] = [
      {
        key: "total_energy_consumed",
        translation: "dashboardConsumedEnergy",
        title: "",
        subtitle: this.$t(
          "components.cards.title.dashboardConsumedEnergy"
        ) as string,
        subtitleClass: "light-blue-1",
        iconColor: "light-blue-1 h-6",
        icon: "generic/icon-energy-consumed.svg",
        consumption: 0,
        unit: "MWh",
      },
      {
        key: "total_energy_consumed_electric_vehicle",
        translation: "dashboardElectricVehicleConsumedEnergy",
        title: "",
        subtitle: this.$t(
          "components.cards.title.dashboardElectricVehicleConsumedEnergy"
        ) as string,
        subtitleClass: "light-blue-1",
        iconColor: "light-blue-1 h-4",
        icon: "devices/icon-electric-vehicle.svg",
        consumption: 0,
        unit: "MWh",
      },
      {
        key: "total_energy_produced",
        translation: "dashboardProducedEnergy",
        title: "",
        subtitle: this.$t(
          "components.cards.title.dashboardProducedEnergy"
        ) as string,
        subtitleClass: "light-blue-1",
        iconColor: "light-blue-1 h-4",
        icon: "generic/icon-energy-produced.svg",
        consumption: 0,
        unit: "MWh",
      },
      {
        key: "total_monitored_households",
        translation: "dashboardMonitoredHouseholds",
        title: "",
        subtitle: this.$t(
          "components.cards.title.dashboardMonitoredHouseholds"
        ) as string,
        subtitleClass: "light-blue-1",
        iconColor: "light-blue-1 h-4",
        icon: "menus/icon-dashboard.svg",
        consumption: 0,
        unit: "uni",
      },
    ];
    return {
      baseItems,
      autoplayInterval: 3000 as number,
      currentSlide: 0 as number,
      duplicateForLoop: false as boolean,
    };
  },
  computed: {
    pageSize(): number {
      const bp = (this as any).$vuetify?.breakpoint || {};
      if (bp.lgAndUp) return 4;
      if (bp.smAndUp) return 2;
      return 1;
    },
    sourceItems(): MeasurementItem[] {
      const src = this.baseItems.slice();
      return this.duplicateForLoop ? src.concat(src) : src;
    },
    pages(): MeasurementItem[][] {
      return this.chunk<MeasurementItem>(this.sourceItems, this.pageSize);
    },
  },
  watch: {
    "$i18n.locale"() {
      this.baseItems = this.baseItems.map((item) => {
        return {
          ...item,
          subtitle: this.$t(
            `components.cards.title.${item.translation}`
          ) as string,
        };
      });
    },
    pages(newPages: any[]) {
      const lastIdx = Math.max(0, newPages.length - 1);
      if (this.currentSlide > lastIdx) {
        this.currentSlide = lastIdx;
      }
    },
  },
  methods: {
    chunk<T>(arr: T[], size: number): T[][] {
      if (!Array.isArray(arr) || !Number.isFinite(size) || size <= 0) return [];
      const out: T[][] = [];
      for (let i = 0; i < arr.length; i += size) {
        out.push(arr.slice(i, i + size));
      }
      return out;
    },
    goToSlide(i: number) {
      const max = Math.max(0, this.pages.length - 1);
      this.currentSlide = Math.min(Math.max(0, i), max);
    },
    async getOverallInformation() {
      await this.$store.dispatch("dashboardData/getOverallDashboardInfo");
      const data = this.$store.getters["dashboardData/overallDashboardInfo"];

      if (!data) return;

      this.baseItems = this.baseItems.map((item) => {
        if (
          data[item.key] !== undefined &&
          item.key !== "total_monitored_households"
        ) {
          return { ...item, consumption: Math.round(data[item.key] / 1000) };
        }
        return { ...item, consumption: data[item.key] || 0 };
      });
    },
  },
});
